export { default as useProductsIndexContentAiSearch } from './useProductsIndexContentAiSearch';
